import { useId } from 'react';

export function useIconId() {
  const id = useId();
  return `iconRender${id}`;
}
